import { render, staticRenderFns } from "./EditContracts.vue?vue&type=template&id=77dcd8ca&scoped=true&"
import script from "./EditContracts.vue?vue&type=script&lang=js&"
export * from "./EditContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dcd8ca",
  null
  
)

export default component.exports